
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
const PageConst= {
  ACTION: {
    doDelete: { api: 'M1022TeachSubjectService.M21601_doDelete' },
    doBrowse: { api: 'M1022TeachSubjectService.M21601_doBrowse' },
    getEdit: { api: 'M1022TeachSubjectService.M21601_getEdit'},
    doEdit: { api: 'M1022TeachSubjectService.M21601_doEdit'},
    doAdd: { api: 'M1022TeachSubjectService.M21601_doAdd'},
    getSubjectList: { api: 'M1020SubjectService.getAllSubjects', input: {}},
    getSubjectsDropdown: { api: 'M1020SubjectService.getSubjectsDropdown'},
    getMaxSubjectNumber: {
      api: 'M1020SubjectService.getMaxSubjectNumber'
    },

  },
}

const module = {
  state: {
    PageConst,
    total_row_count : 0,
    subjectsList: [],
    primarySubjectList: [],
    secondarySubjectList: [],
    tertiarySubjectList: [],
    valueList: {},
  },
  getters: {
    getDropdownList (state){
      return {
        subject_group_no: [
          { label: window.vue.$i18n.t('M21601.subject_group_no_0'), value: 0 },
          { label: window.vue.$i18n.t('M21601.subject_group_no_1'), value: 1 },
          { label: window.vue.$i18n.t('M21601.subject_group_no_2'), value: 2 },
          { label: window.vue.$i18n.t('M21601.subject_group_no_3'), value: 3 },
          { label: window.vue.$i18n.t('M21601.subject_group_no_4'), value: 4 },
          { label: window.vue.$i18n.t('M21601.subject_group_no_5'), value: 5 }
        ],
        subject_classification: [
          { label: window.vue.$i18n.t('M21601.subject_classification_1'), value: 1 },
          { label: window.vue.$i18n.t('M21601.subject_classification_2'), value: 2 },
          { label: window.vue.$i18n.t('M21601.subject_classification_3'), value: 3 },
          { label: window.vue.$i18n.t('M21601.subject_classification_31'), value: 31 },
          { label: window.vue.$i18n.t('M21601.subject_classification_32'), value: 32 },
          { label: window.vue.$i18n.t('M21601.subject_classification_33'), value: 33 },
          { label: window.vue.$i18n.t('M21601.subject_classification_50'), value: 50 }
        ],
        
      }
    },
  },
  mutations: {},
  actions: {
    async M21601_doBrowse_AtDataTable({dispatch, state}) {
      return await dispatch('doBrowse_AtDataTable', {
        orderBy: state.orderBy,
        pagination: state.pagination
      });
    },
    async M21601_doAdd({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M1022TeachSubjectService.M21601_doAdd', input: payload },
        ]
      })
    },
    async M21601_getEdit({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M1022TeachSubjectService.M21601_getEdit', input: payload },
        ]
      }).then((res) => {
        return res[0].output;
      })
    },
    async M21601_doEdit({dispatch, state}, payload) {
      return await $this.$api.postData({
        data: [
          { api: 'M1022TeachSubjectService.M21601_doEdit', input: payload },
        ]
      })
    },
    async getValueList ({ state }) {
      const res = await $this.$api.postData({
        data: {
          valueList: { api: 'T2010TeacherBasicService.C10101_getDropdownData' },
        }
      })
      state.valueList = res.valueList.output
    },
    // @deprecated
    async getSubjectsDropdown ({ state }, { studentClassification }) {
      const res = await $this.$api.postData({
        data: [{
          ...PageConst.ACTION.getSubjectsDropdown,
          input: { student_classification:studentClassification }
        }]
      })
      state.subjectsList = res[0].output;
    },
    async exportCSV ({ state }) {
      const res = await $this.$api.postData({
        data: [{
          api: 'M1022TeachSubjectService.M21601_exportCSV',
          input: { searchInfo: state.searchInfo }
        }]
      })
      return res[0].output;
    },
    async getMaxSubjectNumber({dispatch, state}) {
      return await $this.$api.postData({
        data: [
          { api: 'M1022TeachSubjectService.getMaxSubjectNumber'},
        ]
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
